import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.FeatureFlaggingPage.title',
    defaultMessage: 'Feature Flags',
  },
  subtitle: {
    id: 'containers.FeatureFlaggingPage.subtitle',
    defaultMessage: 'Manage feature flags per user.',
  },
  searchPlaceholder: {
    id: 'containers.FeatureFlaggingPage.searchPlaceholder',
    defaultMessage: 'Search users...',
  },
  noUserSelected: {
    id: 'containers.FeatureFlaggingPage.noUserSelected',
    defaultMessage: 'Select a user to manage their feature flags.',
  },
  noFlags: {
    id: 'containers.FeatureFlaggingPage.noFlags',
    defaultMessage: 'No feature flags available for this user.',
  },
  columnName: {
    id: 'containers.FeatureFlaggingPage.columnName',
    defaultMessage: 'Name',
  },
  columnEmail: {
    id: 'containers.FeatureFlaggingPage.columnEmail',
    defaultMessage: 'Email',
  },
  flagsFor: {
    id: 'containers.FeatureFlaggingPage.flagsFor',
    defaultMessage: 'Feature flags for {name}',
  },
})
